import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectIsPrimerEnabled } from 'root-redux/selects/common'

import { useABTest } from './useABTest'

export const useIsPrimerEnabled = (): boolean => {
  const isEnabled = useSelector(selectIsPrimerEnabled)
  const { isPrimerFormActive } = useABTest()

  return useMemo(() => {
    return isEnabled && isPrimerFormActive
  }, [isEnabled, isPrimerFormActive])
}
